<div class="accordion-container flex flex-col gap-8 mb-8">
    <cdk-accordion>
        <cdk-accordion-item #mainInfo="cdkAccordionItem">
            <button
                class="accordion-button flex justify-between w-full bg-canna-accordion-background p-4 border-b border-canna-primary"
                (click)="mainInfo.toggle()" [attr.aria-expanded]="mainInfo.expanded">
                <span>Meine Daten</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="mainInfo.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (mainInfo.expanded) {
                <div
                    class="accordion-body bg-canna-accordion-background p-4 border-b border-canna-primary"
                    role="region" [style.display]="mainInfo.expanded ? '' : 'none'">
                    <form [formGroup]="profileForm">
                        <div class="form-group">
                            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div class="form-control">
                                    <label>Vorname</label>
                                    <input matInput type="text" formControlName="firstName">
                                </div>
                                <div class="form-control">
                                    <label>Nachname</label>
                                    <input matInput type="text" formControlName="lastName">
                                </div>
                                <div class="form-control">
                                    <label>Geburtsdatum</label>
                                    <div class="datepicker-range">
                                        <input matInput [matDatepicker]="picker" formControlName="dateOfBirth" class="w-full">
                                        <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
                                        <mat-datepicker #picker  [touchUi]="isMobile"></mat-datepicker>
                                    </div>
                                </div>
                                <div class="form-control">
                                    <label>E-Mail</label>
                                    <input matInput type="text" formControlName="email">
                                </div>
                                <div class="form-control">
                                    <label>Mobilnummer</label>
                                    <input matInput type="text" formControlName="mobileNumber">
                                </div>
                                <div class="form-control">
                                    <label>Telefonnummer</label>
                                    <input matInput type="text" formControlName="phoneNumber">
                                </div>
                            </div>
                        </div>

                    </form>
                    <div class="flex justify-end">
                        <button class="btn-primary" (click)="updateProfile()">Profil aktualisieren</button>
                    </div>
                </div>
            }
        </cdk-accordion-item>
    </cdk-accordion>
    <cdk-accordion>
        <cdk-accordion-item #adresses="cdkAccordionItem">
            <button
                class="accordion-button flex justify-between w-full bg-canna-accordion-background p-4 border-b border-canna-primary"
                (click)="adresses.toggle()" [attr.aria-expanded]="adresses.expanded">
                <span>Adressen</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="adresses.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (adresses.expanded) {
                <div
                    class="accordion-body bg-canna-accordion-background p-4 border-b border-canna-primary"
                    role="region" [style.display]="adresses.expanded ? '' : 'none'">

                    <h3 class="mb-4">Rechnungsadresse</h3>
                    <form [formGroup]="invoiceAddressForm">
                        <div class="form-group">
                            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div class="form-control">
                                    <label>Straße</label>
                                    <input matInput type="text" formControlName="street">
                                </div>
                                <div class="form-control">
                                    <label>Hausnummer</label>
                                    <input matInput type="text" formControlName="houseNumber">
                                </div>
                                <div class="form-control">
                                    <label>Wohnort</label>
                                    <input matInput type="text" formControlName="city">
                                </div>
                                <div class="form-control">
                                    <label>PLZ</label>
                                    <input matInput type="text" formControlName="zipCode">
                                </div>
                            </div>
                        </div>
                    </form>
                    <h3 class="mb-4">Lieferadresse</h3>
                    <form [formGroup]="deliveryAddressForm">
                        <div class="form-group">
                            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div class="form-control">
                                    <label>Straße</label>
                                    <input matInput type="text" formControlName="street">
                                </div>
                                <div class="form-control">
                                    <label>Hausnummer</label>
                                    <input matInput type="text" formControlName="houseNumber">
                                </div>
                                <div class="form-control">
                                    <label>Wohnort</label>
                                    <input matInput type="text" formControlName="city">
                                </div>
                                <div class="form-control">
                                    <label>PLZ</label>
                                    <input matInput type="text" formControlName="zipCode">
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="flex justify-end">
                        <button class="btn-primary" (click)="updateProfile()">Adressen aktualisieren</button>
                    </div>


                </div>
            }
        </cdk-accordion-item>
    </cdk-accordion>

    <cdk-accordion>
        <cdk-accordion-item #regularPharmacy="cdkAccordionItem">
            <button
                class="accordion-button flex justify-between w-full bg-canna-accordion-background p-4 border-b border-canna-primary"
                (click)="regularPharmacy.toggle()" [attr.aria-expanded]="regularPharmacy.expanded">
                <span>Standard Apotheke</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="regularPharmacy.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (regularPharmacy.expanded) {
                <div
                    class="accordion-body bg-canna-accordion-background p-4 border-b border-canna-primary"
                    role="region" [style.display]="regularPharmacy.expanded ? '' : 'none'">
                    <div class="form-group">
                        <div class="form-control">
                            <label>
                                Apothekenauswahl
                            </label>
                            <mat-select [formControl]="pharmacyIdFormControl" (selectionChange)="checkDisabledState()">
                                <mat-option [value]="''">Bitte Wählen</mat-option>
                                <mat-option [value]="'custom'">Eigene Apotheke</mat-option>
                                <mat-option [value]="'none'">Keine Apotheke auswählen (Rezept mir direkt zustellen)</mat-option>
                                @for (pharmacy of pharmacyList; track pharmacy.id) {
                                    <mat-option [value]="pharmacy.id">{{ pharmacy.name }}</mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>

                    @if (pharmacyIdFormControl.value !== '' && pharmacyIdFormControl.value !== 'none') {
                        <div class="info-text mb-4 text-canna-secondary pt-2">
                            Wenn Sie eine eigene Apotheke wählen, fallen Rezeptversandkosten an.
                        </div>
                        <form [formGroup]="customPharmacyForm">
                            <div class="form-group">
                                <div class="form-control">
                                    <label>Apothekenname *</label>
                                    <input matInput placeholder="Apothekenname" formControlName="name">
                                </div>
                                <div class="form-control">
                                    <label>Straße *</label>
                                    <input matInput placeholder="Musterstraße" formControlName="street">
                                </div>
                                <div class="form-control">
                                    <label>Hausnummer *</label>
                                    <input matInput placeholder="1"
                                           formControlName="houseNumber">
                                </div>
                                <div class="form-control">
                                    <label>PLZ *</label>
                                    <input matInput placeholder="12345" formControlName="zipCode">
                                </div>
                                <div class="form-control">
                                    <label>Ort *</label>
                                    <input matInput placeholder="Musterhausen" formControlName="city">
                                </div>
                                <div class="form-control">
                                    <label>Telefonnummer *</label>
                                    <input matInput placeholder="+49 123 4567890"
                                           formControlName="phoneNumber">
                                </div>
                            </div>
                            <div class="text-right">* Pflichtfelder</div>
                        </form>
                    }

                    @if (pharmacyIdFormControl.value === 'none' || pharmacyIdFormControl.value === '') {
                        <div class="info-text mb-4 text-canna-secondary pt-2">
                            Wenn Sie keine Apotheke auswählen, wird Ihnen das Rezept auf dem Postweg direkt an Ihre Adresse gesendet. Dadurch entstehende Versandkosten die Ihnen beim Bezahlvorgang nach Rezeptfreigabe berechnet.
                        </div>
                    }

                    <div class="flex justify-end">
                        <button class="btn-primary" (click)="updatePharmacy()">Apotheke aktualisieren</button>
                    </div>
                </div>
            }
        </cdk-accordion-item>
    </cdk-accordion>

    <cdk-accordion>
        <cdk-accordion-item #password="cdkAccordionItem">
            <button
                class="accordion-button flex justify-between w-full bg-canna-accordion-background p-4 border-b border-canna-primary"
                (click)="password.toggle()" [attr.aria-expanded]="password.expanded">
                <span>Neues Passwort</span>
                <i class="fa-solid self-center text-xl"
                   [ngClass]="password.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
            </button>
            @if (password.expanded) {
                <div
                    class="accordion-body bg-canna-accordion-background p-4 border-b border-canna-primary"
                    role="region" [style.display]="password.expanded ? '' : 'none'">
                    <form [formGroup]="passwordForm">
                        <div class="form-group">
                            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                <div class="form-control">
                                    <label>Neues Passwort</label>
                                    <input matInput type="password" formControlName="newPassword">
                                </div>
                                <div class="form-control">
                                    <label>Passwort wiederholen</label>
                                    <input matInput type="password" formControlName="passwordConfirm">
                                    @if (passwordForm.get('passwordConfirm')?.valid && passwordForm.get('newPassword')?.value !== passwordForm.get('passwordConfirm')?.value) {
                                        <mat-error>* Passwörter stimmen nicht überein</mat-error>
                                    }
                                </div>

                            </div>
                        </div>
                    </form>
                    <div class="flex justify-end">
                        <button class="btn-primary" (click)="updatePassword()">Passwort aktualisieren</button>
                    </div>
                </div>
            }
        </cdk-accordion-item>
    </cdk-accordion>

</div>
